import { Checkbox } from '@magnetic/checkbox';
import React, { isValidElement } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const OverflowChildren = /* @__PURE__ */ __name(({
  hidden
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, hidden.map(
  (current) => isValidElement(current) && /* @__PURE__ */ React.createElement(Checkbox, {
    checked: current.props.selected,
    className: "mds-tag-overflow-dropdown-item",
    key: current.props.children,
    onClick: current.props.onClick,
    size: "md"
  }, current.props.children)
)), "OverflowChildren");

export { OverflowChildren };
//# sourceMappingURL=overflow-children.js.map
